import client from './client';

export interface CustomerServiceConversation {
  id: string;
  promoter_id: string;
  promoter_name: string;
  assigned_operator_id: string | null;
  assigned_operator_name: string | null;
  status: 'open' | 'closed';
  last_message: string | null;
  last_message_at: string;
  unread_count: number;
  created_at: string;
  updated_at: string;
}

export interface CustomerServiceMessage {
  id: string;
  conversation_id: string;
  sender_id: string;
  sender_name: string;
  sender_role: 'promoter' | 'operator' | 'super_admin';
  content: string;
  read_at: string | null;
  created_at: string;
}

export interface ApiEnvelope<T> {
  success: true;
  data: T;
}

export interface PaginatedResponse<T> {
  success: true;
  data: T[];
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
}

export const customerServiceApi = {
  getMyConversation: () => client.get('/customer-service/me/conversation'),
  listMessages: (conversationId: string, params?: { page?: number; pageSize?: number }) =>
    client.get(`/customer-service/conversations/${conversationId}/messages`, { params }),
  sendMessage: (conversationId: string, content: string) =>
    client.post(`/customer-service/conversations/${conversationId}/messages`, { content }),
  markRead: (conversationId: string) =>
    client.post(`/customer-service/conversations/${conversationId}/read`),
};
